export default __webpack_public_path__ + "static/media/bg-top.44214379.png";